import angular from 'angular';
import './wiki.scss';
import FileUpload from '~/scripts/services/model/file-upload';
import APIV5 from '~/models/api';
import { NodeService as NodeServiceModel } from '~/scripts/services/model/node-service';
import wikiTemplate from './wiki.html';

/**
 * @memberOf app
 * @ngdoc function
 * @name app.controller:Wiki
 * @param {import('angular').auto.IInjectorService} $injector
 * @param {Knitiv.RootScope} $rootScope - root scope
 * @param {*} this - controller scope
 * @param $location
 * @param $routeParams
 * @param $sce
 * @param $q
 * @param {NodeServiceModel} NodeService
 * @description
 * # Wiki
 * Controller of the app
 */
class wikiCtrl {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').route.IRouteParamsService} $routeParams
	 * @param {import('angular').ISCEService} $sce
	 * @param {import('angular').IQService} $q
	 * @param {any} $scope
	 * @param {any} NodeService
	 * @param {import('angular').ICompileService} $compile
	 */
	constructor(
		$injector,
		$rootScope,
		$location,
		$routeParams,
		$sce,
		$q,
		$scope,
		NodeService,
		$compile,
	) {
		$scope.isLoading = true;
		$scope.isEditionMode = $routeParams.action === 'edit';
		$scope.isViewMode = $routeParams.action === 'view';
		$scope.kid = $routeParams.kid;
		$scope.item = undefined;

		$scope.title = '';
		$scope.model = '';
		$scope.trustedHTML = '';

		$scope.$watch('model', () => {
			const scope = angular.extend($scope.$new(), {
				$ctrl: {},
			});
			const compiled = $compile($scope.model)(scope);
			// @ts-ignore
			const parent = angular.element(document.querySelector('#wiki-preview'));
			// @ts-ignore
			parent.empty();
			// @ts-ignore
			parent.append(compiled);
			// $scope.trustedHTML = $sce.trustAsHtml(element1.innerHTML);
		});

		if ($scope.kid) {
			// API.openFile($scope.kid)
			// 	.then(file => {
			// 		const decoder = new TextDecoder('utf-8');
			// 		$scope.model = decoder.decode(new Uint8Array(file.data));
			// 	})
			// 	.then(() => NodeService.load($scope.kid))
			// 	.then(node => {
			// 		$scope.title = node.name;
			// 		$scope.item = node;
			// 		$scope.isLoading = false;
			// 	})
			// 	.catch(error => {
			// 		console.error('error', error);
			// 		$scope.isLoading = false;
			// 	});
		}
		else {
			$scope.isLoading = false;
		}

		$scope.updateModel = (/** @type {Event} */ $event) => {
			$scope.model = $event;
		};

		$scope.save = async () => {
			const blob = new File([$scope.model], `${$scope.title}.html`, {
				type: 'text/html',
			});
			const upload = new FileUpload($injector, blob, `${$scope.title}.html`);
			// @ts-ignore
			upload.isa = {
				isa: 'K_NODE;SYS_CLASSE',
				isa_name: undefined,
				kid: 'K_NODE;DOCUMENT',
				name: $scope.title,
			};
			try {
				await upload.upload();
				if ($scope.isEditionMode && upload.id) {
					$scope.item.isa.lang.name = $scope.title;
					await NodeService.update($scope.item);
					await APIV5.instance.nodeSetFile({ nodeid: $scope.kid, fileid: upload.id }, { id: 'wiki.save' });
				}
				await upload.prepareFinish();
				if (!$scope.isEditionMode) {
					$location.path(`/wiki/${upload.kid}/edit`)
						.replace();
				}
			}
			catch (error) {
				console.error('Cannot upload', error);
			}
		};
	}
}

export default {
	template: wikiTemplate,
	controller: wikiCtrl,
	controllerAs: 'ctrl',
	title: 'common.workspace',
};
